/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(t,s,i,o){this.targetPoint=t,this.constraint=s,this.isDraped=i,this.domain=o}}export{t as SnappingCandidate};
